export function fullUserName(user) {
  const name = [user.lastName];
  if (user.firstName && user.firstName !== "") {
    name.push(user.firstName);
  }
  if (user.middleName && user.middleName !== "") {
    name.push(user.middleName);
  }
  return name.join(" ");
}
